/* Save the visitor's Google Analytics client ID and session ID on the cart, so the order system can send the purchase to Analytics with the right visitor attached (source, country, campaign).
   - Only runs when the Google tag has already set its own cookies, i.e. the visitor accepted analytics. If they declined or the tag is blocked, nothing is saved and nothing is sent from here.
   - Only touches carts that already have items. Writes two cart attributes (ga_client_id, ga_session_id) that travel onto the order. No personal data. */
(function () {
  try {
    if (window.Shopify && window.Shopify.designMode) { return; }
    var MID = 'G95TJYG3HK';
    var tries = 0, done = '';
    function read() {
      var c = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d+\.(\d+\.\d+)/);
      var s = document.cookie.match(new RegExp('(?:^|;\\s*)_ga_' + MID + '=GS\\d\\.\\d\\.s?(\\d+)'));
      return c ? { cid: c[1], sid: s ? s[1] : '' } : null;
    }
    function check() {
      tries++;
      if (tries > 90) { clearInterval(timer); return; }
      if (!/(?:^|;\s*)cart=/.test(document.cookie)) { return; }
      var ids = read();
      if (!ids) { return; }
      var key = ids.cid + '|' + ids.sid;
      if (done === key) { return; }
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart || !cart.item_count) { return; }
        var a = cart.attributes || {};
        if (a.ga_client_id === ids.cid && (a.ga_session_id || '') === ids.sid) { done = key; return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { ga_client_id: ids.cid, ga_session_id: ids.sid } })
        }).then(function (r) { if (r.ok) { done = key; } });
      }).catch(function () {});
    }
    var timer = setInterval(check, 4000);
    setTimeout(check, 1500);
  } catch (e) {}
})();
